export default __webpack_public_path__ + "static/media/certified-icon.05968ff5.svg";